import React__default, { useMemo } from 'react';
import { Caption } from '../Typography/index.es.js';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BadgeWrapper = styled.div`
  position: relative;
  ${CommonStyles}
`;
const StyledBadge = styled.div(({ theme, top, right, color }) => `
  min-width: ${theme == null ? void 0 : theme.spacing.s16};
  height: ${theme == null ? void 0 : theme.spacing.s16};
  padding: ${theme == null ? void 0 : theme.spacing.s0} ${theme == null ? void 0 : theme.spacing.s4};
  background: ${color ? color : theme == null ? void 0 : theme.colors.error500};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${top ? typeof top === "number" ? `${top}px` : top : 0};
  right: ${right ? typeof right === "number" ? `${right}px` : right : 0};
  transform: translate(50%,-50%);
  transform-origin: 100% 0;
`);
const StyledCaption = styled(Caption)`
  text-align: center;
`;
const Badge = (_a) => {
  var _b = _a, {
    count,
    offset,
    overflowCount = 99,
    showZero = false,
    color,
    children
  } = _b, rest = __objRest(_b, [
    "count",
    "offset",
    "overflowCount",
    "showZero",
    "color",
    "children"
  ]);
  const displayCount = useMemo(() => {
    return count < 0 ? 0 : overflowCount && count > overflowCount ? `${overflowCount}+` : count;
  }, [count, overflowCount]);
  const [top, right] = offset ? offset : [];
  return /* @__PURE__ */ React__default.createElement(BadgeWrapper, __spreadValues({}, rest), children, (count > 0 || count === 0 && showZero) && /* @__PURE__ */ React__default.createElement(StyledBadge, {
    top,
    right,
    color
  }, /* @__PURE__ */ React__default.createElement(StyledCaption, {
    level: 3,
    color: "white"
  }, displayCount)));
};

export { Badge };
